<template>
  <v-app>
    <navbar />
    <v-main>
      
      <v-container
        class="scroll-y"
        fluid>

        <v-row align="center" justify="center">
          <router-view></router-view>
        </v-row>

      </v-container>
      
    </v-main>
  </v-app>
</template>

<script>
import navbar from '@/components/navbar.vue'

export default {
  name: 'App',
  components: {
    navbar
  },
  data: () => ({

  })
};
</script>
